import React from 'react';
import { connect } from 'react-redux';
import { Card } from 'antd';
import * as HttpStatus from 'http-status-codes';
import Layout from '../../components/Layout/Layout';
import AdminLoginForm from '../../components/Login/components/AdminLoginForm';
import { adminLogin, setErrorMessage, loginStatus } from '../../components/Login/LoginAction';
import './AdminLogin.scss';

const AdminLogin = ({ loginStatus, adminLogin, setErrorMessage, ...otherProps }) => {
  return (
    <Layout>
      <div className="admin-login-container">
        <Card className="admin-login-card">
          <AdminLoginForm
            loginHasError={loginStatus !== HttpStatus.OK && loginStatus !== undefined}
            adminLogin={adminLogin}
            setErrorMessage={setErrorMessage}
            {...otherProps}
          />
        </Card>
      </div>
    </Layout>
  );
};

const mapStateToProps = state => ({
  ...state.loginReducer
});

const mapDispatchToProps = {
  adminLogin,
  setErrorMessage,
  setLoginStatus: loginStatus
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminLogin);
